export enum DialogResult {
  Fail,
  Success,
}
